'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _locations = require('../locations');

var _locations2 = _interopRequireDefault(_locations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var school_regions = ["Irish Dance Teachers Association of Canada - Eastern Region", "Western Canada Irish Dance Teachers Association (WCIDTA)", "Irish Dance Teachers Association of Mid-America (IDTAMA)", "IDTANA - Mid-Atlantic Region", "IDTANA - New England Region", "IDTANA - Southern Region", "Western US Regional Council", "Other"];

exports.default = angular.module('ifeis.new-school', ['ngMaterial', 'ifeis.locations']).factory('fNewSchoolDialog', function ($mdDialog, $mdMedia) {
  return function (ev, school, admin) {
    return $mdDialog.show({
      controller: 'NewSchoolDialogController',
      template: require('./tpl.html'),
      targetEvent: ev,
      fullscreen: $mdMedia('xs'),
      locals: {
        school: school ? angular.copy(school) : {},
        edit: !!school,
        admin: admin
      }
    });
  };
}).controller('NewSchoolDialogController', function ($scope, $mdDialog, $window, $mdMedia, fSchoolService, fLocationService, msgService, school, edit, admin) {
  $scope.countries = fLocationService.countries;
  $scope.provinces = [];
  if (school.data && school.data.country !== undefined) {
    $scope.provinces = fLocationService.provincesByCountry(school.data.country);
  }

  $scope.$watch('school.country', function (newCountry, oldCountry) {
    if (newCountry !== oldCountry) {
      $scope.provinces = fLocationService.provincesByCountry(newCountry);
    }
  });

  $scope.regions = school_regions;
  $scope.isModified = false;

  var reportError = function reportError(msg) {
    msgService.displayErrorMsg(msg);
  };

  // Get LiveAgent widget DOM element and hide if on xs display
  // the widget blocks buttons on the form when on mobile
  var liveAgentWgt = void 0;
  if ($window.LiveAgent && $mdMedia('xs')) {
    liveAgentWgt = angular.element(document.getElementById('f-liveagent-contact')).next();
    liveAgentWgt.addClass('f-hidden');
  }

  // store initial school value for checking if changes have been made
  var schoolInit = void 0;
  if (edit) {
    $scope.editing = edit;
    // check if the school passed in is a db response
    if (school && school.data) {
      schoolInit = angular.copy(school.data);
    } else {
      schoolInit = angular.copy(school);
    }
    $scope.school = angular.copy(schoolInit);
  }

  // toggles delete button
  if (admin) {
    $scope.admin = admin;
  }

  $scope.cancel = function () {
    if (liveAgentWgt) {
      liveAgentWgt.removeClass('f-hidden');
    }
    $mdDialog.cancel();
  };

  $scope.submit = function (submit) {
    if ($scope.editing) {
      fSchoolService.one(submit.id).then(function (s) {
        s.update(submit).catch(function () {
          return reportError('Could not update school: ' + submit.name);
        });
        $mdDialog.hide(s);
      }).catch(function () {
        return reportError('Could not find school: ' + submit.name);
      });
    } else {
      fSchoolService.create(submit).then(function (s) {
        $mdDialog.hide(s);
      }).catch(function () {
        reportError('Could not create school: ' + submit.name);
        $mdDialog.hide();
      });
    }
    if (liveAgentWgt) {
      liveAgentWgt.removeClass('f-hidden');
    }
  };

  $scope.remove = function (school) {
    fSchoolService.one(school.id).then(function (s) {
      s.delete().catch(function () {
        var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _err$data = err.data,
            data = _err$data === undefined ? {} : _err$data;

        if (data.errors && data.errors[0] && data.errors[0].detail) {
          reportError(data.errors[0].detail);
        } else {
          reportError('Could not delete school: ' + school.name);
        }
      });
    }).catch(function () {
      return reportError('Could not find school: ' + submit.name);
    });
    if (liveAgentWgt) {
      liveAgentWgt.removeClass('f-hidden');
    }
    $mdDialog.hide();
  };

  // Check if school details were modified,
  // used to determine when to activate submit button
  $scope.checkIfDirty = function () {
    return $scope.isModified = !angular.equals(schoolInit, $scope.school);
  };
});


//////////////////
// WEBPACK FOOTER
// ./new-school/index.js
// module id = 488
// module chunks = 0